import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule, PageSlotModule } from '@spartacus/storefront';
import { ChatMenuComponent } from './chat-menu.component';

@NgModule({
  imports: [NgIf, NgClass, AsyncPipe, IconModule, PageSlotModule],
  declarations: [ChatMenuComponent],
  exports: [ChatMenuComponent],
})
export class ChatMenuComponentModule {}
